// extracted by mini-css-extract-plugin
module.exports = {"featuredJobList__image":"featuredJobList__image","featuredJobList__message":"featuredJobList__message","featuredJobList__publishingPeriod":"featuredJobList__publishingPeriod"};